/**
 * LERA Product Description Premium — Sprint 8.6.3
 * Editorial entrance fade (8.6.1) + Smart Recommendation Engine fetch.
 */

(function () {
  const ROOT = '[data-lera-pd]';
  const SIDEBAR = '[data-lera-rec-sidebar]';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* S9.1: Entrance reveal uses Dawn scroll-trigger + LMS tokens (no local IO). */
  function bindEntrance() {
    /* no-op — retained for API stability */
  }

  function clearSidebarLayout(root) {
    if (!root) return;
    root.classList.remove(
      'lera-pd--with-sidebar',
      'lera-pd--sidebar-desktop',
      'lera-pd--sidebar-tablet',
      'lera-pd--sidebar-mobile'
    );
  }

  function syncSidebarLayout(root) {
    if (!root) return;
    const sidebar = root.querySelector(SIDEBAR);
    const hasCards = Boolean(sidebar && sidebar.querySelector('.lera-rec-card'));
    const pending = sidebar && sidebar.getAttribute('data-lera-recs-pending') === '1';

    if (hasCards && !pending) {
      return;
    }

    if (!hasCards && !pending) {
      sidebar?.remove();
      clearSidebarLayout(root);
    }
  }

  function replaceSidebar(root, nextSidebar) {
    const current = root.querySelector(SIDEBAR);
    if (!nextSidebar) {
      current?.remove();
      clearSidebarLayout(root);
      return;
    }

    nextSidebar.removeAttribute('hidden');
    nextSidebar.style.removeProperty('display');
    nextSidebar.setAttribute('data-lera-recs-pending', '0');

    if (current) {
      current.replaceWith(nextSidebar);
    } else {
      const layout = root.querySelector('.lera-pd__layout');
      if (layout) layout.appendChild(nextSidebar);
    }
  }

  function loadSmartRecommendations(root) {
    const sidebar = root.querySelector(SIDEBAR);
    if (!sidebar) {
      syncSidebarLayout(root);
      return;
    }

    const mode = sidebar.getAttribute('data-lera-recs-mode') || 'smart';
    const loaded = sidebar.getAttribute('data-lera-recs-loaded') === '1';
    const url = sidebar.getAttribute('data-lera-recs-url');

    if (mode !== 'smart' || loaded || !url) {
      syncSidebarLayout(root);
      return;
    }

    if (sidebar.dataset.leraRecsFetch === '1') return;
    sidebar.dataset.leraRecsFetch = '1';

    const runFetch = () => {
      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('Recommendations request failed');
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const next = doc.querySelector(SIDEBAR);
          const nextHasCards = Boolean(next && next.querySelector('.lera-rec-card'));
          const currentHasCards = Boolean(sidebar.querySelector('.lera-rec-card'));

          if (nextHasCards) {
            next.setAttribute('data-lera-recs-loaded', next.getAttribute('data-lera-recs-source') === 'shopify' ? '1' : '0');
            replaceSidebar(root, next);
            syncSidebarLayout(root);
            return;
          }

          if (!currentHasCards) {
            replaceSidebar(root, null);
          } else {
            sidebar.setAttribute('data-lera-recs-pending', '0');
            sidebar.removeAttribute('hidden');
            sidebar.style.removeProperty('display');
            syncSidebarLayout(root);
          }
        })
        .catch(() => {
          sidebar.dataset.leraRecsFetch = '0';
          if (sidebar.getAttribute('data-lera-recs-pending') === '1' && !sidebar.querySelector('.lera-rec-card')) {
            replaceSidebar(root, null);
          } else {
            sidebar.setAttribute('data-lera-recs-pending', '0');
            sidebar.removeAttribute('hidden');
            sidebar.style.removeProperty('display');
            syncSidebarLayout(root);
          }
        });
    };

    if (!('IntersectionObserver' in window)) {
      runFetch();
      return;
    }

    const pending = sidebar.getAttribute('data-lera-recs-pending') === '1';
    const observeTarget = pending ? root : sidebar;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        runFetch();
      },
      { rootMargin: '0px 0px 320px 0px' }
    );

    observer.observe(observeTarget);
  }

  function bootRoot(root) {
    bindEntrance(root);
    loadSmartRecommendations(root);
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach(bootRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  window.LeraProductDescription = window.LeraProductDescription || {};
  window.LeraProductDescription.version = '8.6.3';
  window.LeraProductDescription.refresh = boot;
})();
